import client from 'client';

import { saveBlob } from './saveBlob';

/**
 * Имя файла на случай, если сервер его не прислал. Держим в синхронизации с тем,
 * что формирует API (reports-export/service.js).
 */
function fallbackFilename(projectId, format) {
  const scope = projectId ? `project_${projectId}` : 'all';
  const date = new Date().toISOString().slice(0, 10);
  return `reports_${scope}_${date}.${format === 'json' ? 'json' : 'csv'}`;
}

/**
 * Скачать отчеты пользователя файлом.
 * @param {Object} [obj]
 * @param {Number} [obj.projectId] Только по этому проекту. Если не указан — по всем.
 * @param {'csv'|'json'} [obj.format] По умолчанию csv.
 * @returns {Promise<void>}
 */
export async function downloadReports({ projectId, format } = {}) {
  const { blob, filename } = await client.downloadReports({ projectId, format });
  saveBlob(blob, filename ?? fallbackFilename(projectId, format));
}
